// extracted by mini-css-extract-plugin
module.exports = {"EditorEmployers":"_x_BtByM","titleBlock":"_2yVvku9x","title":"_3uIpK_NO","titleContainer":"_2OsOxEqs","autoSaving":"_1Jg8pVSa","autoSaved":"_2wloVLH4","saveContent":"m826cDe0","errorText":"UvhyXBek","active":"_2L-JXx5i","inactive":"_2OrwhJSb","category":"PR9rHxFO","backButtonContainer":"_14H3df0A","backButton":"_3xxgT2uz"};
    if(module.hot) {
      // 1746735834275
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  